@use "~/styles/mixins" as *;

.root {
  @include df-center;
  width: 100%;
  height: 70vh;
  flex-direction: column;
  gap: 1rem;
}
